import { useCallback } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { TOAST_OPTIONS } from 'common';
import { DataStore } from '../../store';
import { saveBlobAsFile } from '~/utils/save-blob-as-file';

export function useDownloadActivitiesCsv() {
  const getActivitiesCsv = DataStore.useStoreActions(
    a => a.transactions.getActivitiesCsv
  );

  const download = useCallback(
    async (accountId: string) => {
      try {
        const { isSuccessful, result, errorMessage } = await getActivitiesCsv({
          accountId,
        });

        if (isSuccessful && result) {
          saveBlobAsFile(
            result.blob,
            result.filename || 'xbto-transactions.csv'
          );
        } else {
          toast.warn(errorMessage, TOAST_OPTIONS as ToastOptions);
        }
      } catch (error) {
        toast.error('Failed to download CSV', TOAST_OPTIONS as ToastOptions);
      }
    },
    [getActivitiesCsv]
  );

  return download;
}
